import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from 'react-router-dom';

function Contact() {

    const initialForm = {
      fullName: "",
      email: "",
      mobileNumber: "",
      caseType: "",
      description: "",
      captcha: "",
      captcha_token: ""
    };
    const [captchaImage, setCaptchaImage] = useState(" ");
    const [captchaToken, setCaptchaToken] = useState("");
    const [formData, setFormData] = useState(initialForm);
    const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
      captcha_token: captchaToken,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await axios.post(
        "https://laja.gov.pk/api/email_contact_us.php",
        {
          fullName: formData.fullName,
          email: formData.email,
          mobileNumber: formData.mobileNumber,
          caseType: formData.caseType,
          description: formData.description,
          captcha: formData.captcha,
          captcha_token: formData.captcha_token
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        });
      if (response.data.success) {
        alert("Application submitted successfully.");
        setFormData(initialForm);
        getCaptcha();
      } else {
        alert(response.data.message || "Submission failed.");
      }
    } catch (error) {
      console.error(error);
      alert(
        error.response?.data?.message ||
          "Something went wrong. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  // Clear form
  const handleClear = () => {
    setFormData(initialForm);
  };

    const getCaptcha = async () => {
        try {
            const response = await axios.get(
                "https://laja.gov.pk/api/captcha.php",
              {
                  withCredentials: true
              }
            );
            setCaptchaImage(response.data.captcha_image);
            setCaptchaToken(response.data.captcha_token);
        } catch (error) {
            console.error("CAPTCHA error:", error);
        }
    };

    useEffect(() => {
        getCaptcha();
    }, []);

  return (
    <main id="main">

  <div className="page-header">
    <svg viewBox="0 0 100 100" className="page-header__seal" aria-hidden="true" style={{color:'#fff'}}>
      <circle cx="50" cy="50" r="47" fill="none" stroke="currentColor" strokeWidth="0.8"/>
      <path id="sealTopB" d="M 14,50 A 36,36 0 1,1 86,50" fill="none"/>
      <text fontSize="5.4" letterSpacing="1.5" fill="currentColor"><textPath href="#sealTopB" startOffset="50%" textAnchor="middle">JUSTICE FOR ALL</textPath></text>
    </svg>
    <div className="container">
      <div className="breadcrumb"><Link to="/">Home</Link> / Contact Us</div>
      <h1>Get In Touch</h1>
      <p>Have a question, need assistance, or want to connect with us? Reach out to our team for information, support, and guidance. We’re committed to responding to your inquiries and helping you access the Legal Aid services you need.</p>
    </div>
  </div>

  <section className="section">
    <div className="container">
      <div className="form-layout">

        <div className="form-panel">
          <form onSubmit={handleSubmit}>

            <fieldset>
              <legend>Contact Us Form</legend>

              <div className="form-row">
                <div className="form-field">
                  <label htmlFor="fname">Full Name<span className="req">*</span></label>
                  <input type="text" id="fname" name="fullName" value={formData.fullName} onChange={handleChange} placeholder="Enter full name" required />
                </div>
                <div className="form-field">
                  <label htmlFor="email">Email<span className="req">*</span></label>
                  <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} placeholder="xyz@gmail.com" required/>
                </div>
              </div>

              <div className="form-row">
                <div className="form-field">
                  <label htmlFor="phone">Mobile Number<span className="req">*</span></label>
                  <input type="tel" id="phone" name="mobileNumber" value={formData.mobileNumber} onChange={handleChange} placeholder="11-digit mobile number" required />
                </div>
                <div className="form-field">
                <label htmlFor="ctype">Type of Case<span className="req">*</span></label>
                <select id="ctype" name="caseType" value={formData.caseType} onChange={handleChange} required>
                  <option value="">Select Issue</option>
                  <option value="Legal Assistance">Legal Assistance</option>
                  <option value="Criminal Case">Criminal Case</option>
                  <option value="Sexual Offense">Sexual Offense</option>
                  <option  value="Delay In Case Proceedings">Delay In Case Proceedings</option>
                  <option value="General Inquiry">General Inquiry</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              </div>

              <div className="form-field">
                <label htmlFor="desc">Description<span className="req">*</span></label>
                <textarea id="desc" name="description" value={formData.description} onChange={handleChange} maxLength="2000" required placeholder="Have a question, need assistance, or want to connect with us? Reach out to our team for information." />
                <span className="hint">Maximum 2,000 characters.</span>
              </div>

              <div className="form-row">
                <div className="form-field">
                  <label htmlFor="captcha">Type Captcha Code<span className="req">*</span></label>
                  <input id="captcha" type="text" name="captcha" value={formData.captcha} onChange={handleChange} placeholder="Enter Captcha Code" required/>
                </div>
                <div className="form-field">
                  <button className="captcha_refresh_btn" type="button" onClick={getCaptcha}>REFRESH CAPTCHA</button>
                  <img src={captchaImage} alt="CAPTCHA" height='40'/>
                </div>
              </div>
            </fieldset>


            <div className="form-actions">
              <button type="submit" disabled={loading} className="btn btn--gold">{loading ? "Submitting..." : "Submit Application"}</button>
              <button type="reset" onClick={handleClear} className="btn btn--outline-navy">Clear Form</button>
            </div>
            <p className="form-note">Fields marked <span className="req">*</span> are mandatory.</p>

          </form>
        </div>

        <aside>
          <div className="receipt-card">
            <h3 style={{textAlign:'center'}}>Get in touch with us directly</h3>
            <p>Connect with us directly for inquiries, assistance, and further information.</p>
            <div className="receipt-line"><span>Hotline</span><span>051-9201790</span></div>
            <div className="receipt-line"><span>Email</span><span>contact@laja.gov.pk</span></div>
            <div className="receipt-line"><span>Office Hours</span><span>8:30 AM - 4:30 PM</span></div>
            <div className="receipt-line"><span>Working Days</span><span>Monday - Friday</span></div>
          </div>

          <div className="helpline-box">
            <h4>Need help filling this form?</h4>
            <p>Call the helpline, Monday&ndash;Friday, 8:30AM&ndash;4:30PM.</p>
            <p className="phone">051-9201790</p>
            <p style={{marginTop:'10px'}}>Or visit LAJA HQ 10th Floor, State life Building No. 5, Blue Area, F6, Islamabad.</p>
          </div>
        </aside>

      </div>
    </div>
  </section>

</main>
  );
}

export default Contact;
